import { render, staticRenderFns } from "./TheWellboreIntervalElementAreas.vue?vue&type=template&id=71e2ed42"
import script from "./TheWellboreIntervalElementAreas.vue?vue&type=script&lang=ts"
export * from "./TheWellboreIntervalElementAreas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports